import {getCrossPseudoId, onCrossPseudoIdChange, waitForAmplitudeInitialization} from "@pg-mono/amplitude";

import {gtag} from "./gtag";

let lastPushedCrossPseudoId: string | null | undefined;

const pushCrossPseudoIdToGtag = (crossPseudoId: string | null): void => {
    if (crossPseudoId === lastPushedCrossPseudoId) {
        return;
    }

    lastPushedCrossPseudoId = crossPseudoId;
    gtag("set", "user_properties", {cross_pseudo_id: crossPseudoId});
};

export const syncCrossPseudoIdWithGa4 = async (): Promise<void> => {
    // subscribe before Amplitude finishes initializing, so the id is pushed the moment it is published
    onCrossPseudoIdChange(pushCrossPseudoIdToGtag);

    await waitForAmplitudeInitialization();

    pushCrossPseudoIdToGtag(getCrossPseudoId() ?? null);
};
import {getCrossPseudoId, onCrossPseudoIdChange, waitForAmplitudeInitialization} from "@pg-mono/amplitude";

import {gtag} from "./gtag";

let lastPushedCrossPseudoId: string | null | undefined;

const pushCrossPseudoIdToGtag = (crossPseudoId: string | null): void => {
    if (crossPseudoId === lastPushedCrossPseudoId) {
        return;
    }

    lastPushedCrossPseudoId = crossPseudoId;
    gtag("set", "user_properties", {cross_pseudo_id: crossPseudoId});
};

export const syncCrossPseudoIdWithGa4 = async (): Promise<void> => {
    // subscribe before Amplitude finishes initializing, so the id is pushed the moment it is published
    onCrossPseudoIdChange(pushCrossPseudoIdToGtag);

    await waitForAmplitudeInitialization();

    pushCrossPseudoIdToGtag(getCrossPseudoId() ?? null);
};
